import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { MermaidAPI } from 'ngx-markdown';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ChatMessage } from 'src/app/models/conversations.interface';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkdownModule, MatIconModule, MatButtonModule, MatTooltipModule]
})
export class MessageListComponent {
  @Input() messages: ChatMessage[] = [];
  @Input() loading = false;
  @Input() isTyping = false;
  @Input() currentTypingMessage: ChatMessage | null = null;

  mermaidChartingConfig: MermaidAPI.Config = {
    fontFamily: '"Slalom Sans", "Roboto", sans-serif',
    logLevel: MermaidAPI.LogLevel.Error,
    theme: MermaidAPI.Theme.Forest
  };
  @Output() draftSectionEvent = new EventEmitter<string>();
  @Output() snackbarEvent = new EventEmitter<string>();

  copyToClipboard(message: string) {
    navigator.clipboard.writeText(message);
    this.snackbarEvent.emit('Copied to clipboard');
  }

  draftSection(msg: string) {
    this.draftSectionEvent.emit(msg);
  }
}
